import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { TextContext } from "context/TextProvider.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// custom components
import { Typography } from "@material-ui/core";

import malediwy1 from "assets/img/trips/malediwy/malediwy1.jpg";
import malediwy2 from "assets/img/trips/malediwy/malediwy2.jpg";
import malediwy3 from "assets/img/trips/malediwy/malediwy3.jpg";
import malediwy4 from "assets/img/trips/malediwy/malediwy4.jpg";
import Calendarium from "../../Calendarium/Calendarium.js";
import TripsCarusel from "../TripsCarusel.js";

import banner from "assets/img/banner/malediwy.jpg";
import setBanner from "utils/setBanner";
import setSlogan from "utils/setSlogan";
import setVideo from "utils/setVideo";

import MetaSEO from "components/MetaSEO/MetaSEO.js";
import setH1 from "utils/setH1.js";

import { applyHiddenAnimation } from "utils/applyHiddenAnimation";

const useStyles = makeStyles(styles);

const Malediwy = (props) => {
  const dictionary = useContext(TextContext);
  const { language } = useParams();
  useEffect(() => {
    setVideo(false);
    setBanner(banner);
    setSlogan(dictionary.malediwy.slogan1, dictionary.malediwy.slogan2);
    setH1(dictionary.malediwy.H1);
  });

  useEffect(() => {
    return applyHiddenAnimation();
  }, []);

  const classes = useStyles();

  const images = [malediwy1, malediwy2, malediwy3, malediwy4];

  return (
    <div>
      <MetaSEO url={`/${language}/trips/malediwy`} />

      <Typography
        variant="h4"
        className={`${classes.description} hidden`}
        align="left"
      >
        {dictionary.malediwy.title1}
      </Typography>
      <Typography
        variant="h5"
        className={`${classes.description} hidden`}
        align="left"
      >
        {dictionary.malediwy.title2}
      </Typography>
      <br />

      <div className="hidden">
        <TripsCarusel images={images} location={dictionary.malediwy.location} />
      </div>

      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12} md={12} className="hidden">
          <Calendarium filter="malediwy" {...props} />
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <Typography
            variant="body1"
            className={`${classes.description} hidden`}
            align="left"
          >
            {dictionary.malediwy.text1}
          </Typography>
          <br />
          <Typography
            variant="body1"
            className={`${classes.description} hidden`}
            align="left"
          >
            {dictionary.malediwy.text2}
          </Typography>
          <br />

          <a href="mailto:office@nautilus.com.pl">office@nautilus.com.pl</a>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default Malediwy;
